import React from 'react';
import PropTypes from 'prop-types';
import {MessageSquare, Shield} from 'lucide-react';

const EmptyState = ({ 
  type, 
  title, 
  message, 
  icon, 
  variant = 'mobile',
  actionLabel,
  onAction 
}) => {
  const containerClasses = variant === 'desktop' 
    ? 'py-12 px-6 text-center'
    : 'py-8 px-4 text-center';
  
  const iconClasses = variant === 'desktop' 
    ? 'w-20 h-20 mx-auto mb-6'
    : 'w-16 h-16 mx-auto mb-4';
  
  const titleClasses = variant === 'desktop' 
    ? 'text-xl font-semibold text-gray-900 mb-2'
    : 'text-lg font-semibold text-gray-900 mb-2';
  
  const messageClasses = variant === 'desktop' 
    ? 'text-gray-600 mb-8 max-w-md mx-auto'
    : 'text-gray-600 mb-6';

  const defaultProps = {
    chats: {
      title: 'No conversations',
      message: 'Start a conversation with sellers',
      icon: <MessageSquare className={iconClasses} />
    },
    escrow: {
      title: 'No escrow history',
      message: 'Your escrow transactions will appear here once you make or receive secure payments',
      icon: <Shield className={iconClasses} />
    }
  };

  const props = {
    title: title || defaultProps[type]?.title,
    message: message || defaultProps[type]?.message,
    icon: icon || defaultProps[type]?.icon
  };

  return (
    <div className={`bg-white rounded-2xl shadow-sm ${containerClasses}`}>
      <div className={iconClasses.replace('mx-auto mb-6', '').replace('mx-auto mb-4', '')}>
        {props.icon}
      </div>
      <h3 className={titleClasses}>{props.title}</h3>
      <p className={messageClasses}>{props.message}</p>
      
      {actionLabel && onAction && (
        <button
          onClick={onAction}
          className="bg-[#ff660e] text-white px-6 py-2.5 rounded-lg font-semibold hover:bg-[#ff5500] transition-colors"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
};

EmptyState.propTypes = {
  type: PropTypes.oneOf(['chats', 'escrow']).isRequired,
  title: PropTypes.string,
  message: PropTypes.string,
  icon: PropTypes.node,
  variant: PropTypes.oneOf(['mobile', 'desktop']),
  actionLabel: PropTypes.string,
  onAction: PropTypes.func
};

export default EmptyState;